import React from 'react'
import { useWindowDimensions } from '../lib/window'
import store from '../redux/store'
import { setMobile } from '../redux/actions/browser'

const WindowSize = () => {
  const { width } = useWindowDimensions()

  React.useEffect(() => {
    store.dispatch(setMobile(width <= 667))
  }, [width])

  return (
    <div />
  )
}

export default WindowSize
